import React from "react";
import "./Signup.css";
import Topbar from "../../Components/Topbar/Topbar";
import Navbar from "../../Components/Navbar/Navbar";
import Footer from "../../Components/Footer/Footer";
import Banner2 from "../../Components/Banner/Banner2";
import SignupForm from "./Components/SignupForm/SignupForm";

const Signup = () => {
  return (
    <div className="contactus__screen">
      <Topbar />
      <Navbar />
      <Banner2
        heading="Sign Up"
        description="Register with SerenaTax in minutes to file returns"
      />
      <SignupForm />
      <Footer />
    </div>
  );
};

export default Signup;
